// ============================================================
// services/derivacionPsicologicaService.ts
// /derivaciones-psicologicas — bandeja del psicólogo y "mías".
// ============================================================

import { httpClient } from 'utils/httpClient';
import {
  DerivacionPayload,
  DerivacionEstadoPayload,
  DerivacionResponse,
  EstadoDerivacion,
} from 'types/psicologia.types';

export const derivacionPsicologicaService = {

  async crear(payload: DerivacionPayload): Promise<DerivacionResponse> {
    return httpClient.post<DerivacionResponse>('/derivaciones-psicologicas', payload);
  },

  /** Bandeja para psicólogo / admin / director. */
  async listar(estado?: EstadoDerivacion): Promise<DerivacionResponse[]> {
    const q = estado ? `?estado=${encodeURIComponent(estado)}` : '';
    const data = await httpClient.get<DerivacionResponse[]>(`/derivaciones-psicologicas${q}`);
    return Array.isArray(data) ? data : [];
  },

  async listarPorMatricula(matriculaId: number): Promise<DerivacionResponse[]> {
    const data = await httpClient.get<DerivacionResponse[]>(
      `/derivaciones-psicologicas/matricula/${matriculaId}`,
    );
    return Array.isArray(data) ? data : [];
  },

  /** Lo que el usuario autenticado ha derivado. */
  async listarMias(): Promise<DerivacionResponse[]> {
    const data = await httpClient.get<DerivacionResponse[]>(`/derivaciones-psicologicas/mias`);
    return Array.isArray(data) ? data : [];
  },

  async actualizarEstado(id: number, payload: DerivacionEstadoPayload): Promise<DerivacionResponse> {
    return httpClient.put<DerivacionResponse>(`/derivaciones-psicologicas/${id}/estado`, payload);
  },
};
